import { defaultLocale, getValidLocale } from '@/helpers/locale'

const resolveLocale = (locale: string | null | undefined): string => getValidLocale(locale, true) ?? defaultLocale

export const makeCompact = (locale: string): ((value: number) => string) => {
  const formatter = new Intl.NumberFormat(resolveLocale(locale), { notation: 'compact' })
  return (value) => formatter.format(value)
}

export const makeNumber = (locale: string): ((value: number) => string) => {
  const formatter = new Intl.NumberFormat(resolveLocale(locale))
  return (value) => formatter.format(value)
}

export const makeFixed = (locale: string, fractionDigits = 1): ((value: number) => string) => {
  const formatter = new Intl.NumberFormat(resolveLocale(locale), {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })
  return (value) => formatter.format(value)
}

export const makeRatioPercent = (locale: string, fractionDigits = 1): ((value: number) => string) => {
  const formatter = new Intl.NumberFormat(resolveLocale(locale), {
    style: 'percent',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })
  return (value) => formatter.format(value)
}

export const makeCountShare = (locale: string, total: number): ((value: number) => string) => {
  const number = makeNumber(locale)
  const percent = makeRatioPercent(locale, 0)
  return (value) => (total > 0 ? `${number(value)} · ${percent(value / total)}` : number(value))
}

export const makeSigned = (locale: string, fractionDigits?: number): ((value: number) => string) => {
  const formatter = new Intl.NumberFormat(resolveLocale(locale), {
    signDisplay: 'exceptZero',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })
  return (value) => formatter.format(value)
}

export const makeSignedPercent = (locale: string, fractionDigits = 1): ((value: number) => string) => {
  const formatter = new Intl.NumberFormat(resolveLocale(locale), {
    style: 'percent',
    signDisplay: 'exceptZero',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })
  return (value) => formatter.format(value)
}
